import { ref, watchEffect } from 'vue'
import { useHelpers, useTranslate } from '@/shared/lib'
import { type EventFilterType } from '@/entities/Events'
import { DateTime } from 'ts-luxon'
import { cloneDeep } from 'lodash'
import { useLoadWidgetEvents } from '@/widgets/ObjectEventsItem/model/api.ts'

export const useModel = () => {
  const { trs } = useTranslate()
  const { toTimeFormat } = useHelpers()

  const dateFormat: string = "yyyy-LL-dd'T'HH:mm"
  const perPageList = [5, 10]

  const total = ref(0)
  const data = ref<any[]>([])

  const filter = ref<EventFilterType>({
    date_from: DateTime.now().minus({ day: 1 }).toFormat(dateFormat),
    date_to: DateTime.now().toFormat(dateFormat),
    only_errors: 1,
    event_types: [],
    page: 1,
    per_page: 5,
  })

  /**
   * Настройки шапки
   */
  const headers = ref([
    {
      title: trs('itf.time'),
      key: 'server_created_at',
      sortable: false,
      value: ({ server_created_at }) => toTimeFormat(server_created_at, 'dd.MM.yyyy HH:mm:ss'),
    },
    {
      title: trs('itf.object_time'),
      key: 'device_created_at',
      sortable: false,
      value: ({ device_created_at }) =>
        device_created_at ? toTimeFormat(device_created_at, 'dd.MM.yyyy HH:mm:ss') : '-',
    },
    { title: trs('itf.event'), key: 'new_value', sortable: false },
  ])

  /**
   * Функция загрузки данных
   */
  const loadData = () => {
    const result = useLoadWidgetEvents(filter.value)

    watchEffect(() => {
      if (result.data.value) {
        data.value = cloneDeep(result.data.value.data || [])
        total.value = result.data.value.payload.total
      }
    })

    return result
  }

  return {
    data,
    headers,
    filter,
    total,
    perPageList,

    loadData,
  }
}
